import { useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routesLinks, trackButtonClick, trackSelectedActions } from '../utils/RouteConstants';

const VOICE_CONVERSATION_ROUTES = [routesLinks.home, routesLinks.homev1, routesLinks.homev2];
export const START_VOICE_CONVERSATION_STATE_KEY = 'startVoiceConversation';

export const ENQUIRY_OPTIONS = [
  "I’m a school leader and I’d like to know how SchoolAi can help my school",
  "I’m a student and my school has given me login credentials",
  "I’m a teacher already registered with SchoolAi",
];

export const useEnquiry = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const actionButtonRef = useRef(null);
  const avoidOverlapRef = useRef(null);

  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [openSchoolForm, setOpenSchoolForm] = useState(false);
  const [selectedBtn, setSelectedBtn] = useState("");
  const [dropdownDirection, setDropdownDirection] = useState('top');

  const onOptionSelect = (idx, option) => {
    trackSelectedActions(option, selectedBtn);

    // Close drawer + immediately restore body scroll (don't wait for useEffect)
    // iOS Safari requires Zoho to be called synchronously within the user gesture —
    // setTimeout would break the gesture chain and Zoho won't open on mobile.
    setEnquiryOpen(false);
    document.body.style.overflowY = '';

    if (idx === 0) {
      if (!VOICE_CONVERSATION_ROUTES.includes(location.pathname)) {
        navigate(routesLinks.home, { state: { [START_VOICE_CONVERSATION_STATE_KEY]: true } });
        return;
      }
      const scrollContainer = document.querySelector('.mobile-inner-scroll');
      if (scrollContainer) {
        scrollContainer.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
      window.dispatchEvent(new CustomEvent('startVoiceConversation'));
    } else if (idx === 1 || idx === 2) {
      try {
        if (window.$zoho && window.$zoho.salesiq) {
          window.$zoho.salesiq.floatwindow.visible('show');
          window.$zoho.salesiq.chat.start();
          window.$zoho.salesiq.visitor.question(option);
        } else {
        }
      } catch (e) {
      }
    }
  };

  const handleCloseForm = () => {
    setOpenSchoolForm(false);
  };

  const toggleEnquiry = (ref, btnLabel, avoidOverlapEl, direction = 'top') => {
    actionButtonRef.current = ref;
    avoidOverlapRef.current = avoidOverlapEl || null;
    setSelectedBtn(btnLabel);
    setDropdownDirection(direction);
    trackButtonClick(btnLabel);
    setEnquiryOpen((prev) => !prev);
  };

  const handleEnquiryClick = (btnLabel) => {
    trackButtonClick(btnLabel);
    setOpenSchoolForm(true);
  };

  const handleEnquiry = (ref, btnLabel, avoidOverlapEl, direction = 'top') => {
    // Determine if we should open the drawer or the form directly
    // This logic matches LandingPageV1's specific behavior for certain routes
    const isHomeDirect =
      location.pathname === routesLinks.homev1 ||
      location.pathname === routesLinks.homev2;

    if (isHomeDirect) {
      handleEnquiryClick(btnLabel);
    } else {
      toggleEnquiry(ref, btnLabel, avoidOverlapEl, direction);
    }
  };

  return {
    enquiryOpen,
    setEnquiryOpen,
    openSchoolForm,
    setOpenSchoolForm,
    selectedBtn,
    setSelectedBtn,
    actionButtonRef,
    avoidOverlapRef,
    dropdownDirection,
    options: ENQUIRY_OPTIONS,
    onOptionSelect,
    handleCloseForm,
    handleEnquiry,
    toggleEnquiry
  };
};
